var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.media.image)?_c('Picture',{style:(_vm.style),attrs:{"show-spinner":false,"image":_vm.media.image,"lazy":true,"missing-icon":false,"fit":"fit","optimize":"speed"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }